



























import {Component, Prop, Vue} from "vue-property-decorator";
import FileUpload from "@/components/common/FileUpload.vue";
import FileMetaDTO from "@/dto/files/FileMetaDTO";
import {namespace} from "vuex-class";
import PayrollService from "@/services/payroll/PayrollService";
import {processError} from "@/utils/ComponentUtils";
import Application from "@/state/Application";

const AppModule = namespace("App");

@Component({
  components: {FileUpload}
})
export default class Upload1042SModal extends Vue {

  @AppModule.State
  private loading!: boolean;

  @AppModule.Action
  private startLoading!: () => void

  @AppModule.Action
  private stopLoading!: () => void

  @Prop()
  private onFilesUploaded!: () => void;

  @Prop()
  private contractorId!: number;

  @Prop()
  private counterpartyType!: string;

  private period = "";

  private isPeriodEntered = false;

  onUploaded(files: FileMetaDTO[]) {
    Application.startLoading();
    PayrollService.saveForm1042S(this.contractorId, this.counterpartyType, files[0].id, this.period).then(
        ok => {
          Application.stopLoading();
          this.onFilesUploaded();
          this.$modal.hideAll();
        },
        err => processError(err, this)
    )
  }


}
